import { render, staticRenderFns } from "./RecordingStorageNotif.vue?vue&type=template&id=58c260dc&"
import script from "./RecordingStorageNotif.vue?vue&type=script&lang=js&"
export * from "./RecordingStorageNotif.vue?vue&type=script&lang=js&"
import style0 from "./RecordingStorageNotif.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports